<template>
    <div class="pb-0 group-title-wrapper" v-if="!disabled">
	<div class="type-label">Series</div>
	<div class="group-title">
                <div class="group-title">
                    <h1 class="mb-0 exclude-outside-click edit-d-title project-title" v-show="!editTitle" @click="activateTitleField">{{ socialSeriesDetail.title }}</h1>
                    <input
                        ref="editTitleRef"
                        v-show="editTitle"
                        type="text"
                        placeholder="Social Media Series..."
                        class="form-control mb-3 title-field exclude-outside-click h1"
                        v-model="socialSeriesDetail.title"
                        v-click-outside="clickOutsideTitle"
                        @change="updateSocialSeries()"
                    />
                </div>
            </div>
        </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { mapActions, mapGetters, mapState } from "vuex";
import CreateLinkModal from "./CreateSocialSeriesLinkModal";
import EditLinkModal from "./EditSocialSeriesLinkModal";
import LinkCopyLinkModal from "../common/LinkCopyLinkModal.vue";
import CustomFields from './SocialSeriesCustomFields.vue';

export default {
    props: ['isEdit', 'disabled', 'namespace'],
    components: {
        'vuejs-datepicker': Datepicker,
        CreateLinkModal,
        EditLinkModal,
        LinkCopyLinkModal,
        CustomFields
    },
    data() {
        const loggedInUser = {id: localStorage.getItem("userId"), name: localStorage.getItem("user")};
        return {
            editTitle: false,
            emEditing: false,
            plEditing: false,
            budgetEditing: false,
            requisitionNumberEditing: false,
            socialSeries: {
                title: "Social Media Series",
                start_date: this.$moment().format(),
                end_date: null,
                engagement_manager: loggedInUser,
                project_lead: loggedInUser,
                budget: null,
                requisitionNumber: "",
            },
            showRemoveSocialSeries: false,
            // Resources
            linkUrl: null,
            linkLabel: null,
            linkNotes: null,
            linkType: null,
            editLinkIsFile: false,
            linkCopyModalValue: "",
        };
    },
    computed:{
    	...mapState({
	      state (state) {
	        return state[this.namespace]
	      },
            allActiveUsers (state, getters) {
            	return getters[this.namespace + 'allActiveUsers']
            },
            allCustomFields (state, getters) {
            	return getters[this.namespace + 'allCustomFields']
            },
            socialSeriesDetail (state, getters) {
            	return getters[this.namespace + 'socialSeriesDetail']
            },
            userAbilities (state, getters) {
            	return getters['userAbilities']
            },
        }),
        optionsForLinkType() {
            let linkTypeField = this.allCustomFields.find(x => x.id == 37);
            if (!linkTypeField) {
                this.$store.dispatch("fetchAllCustomFields");
            } else {
                return JSON.parse(linkTypeField.value_set);
            }
		},
        _() {
            return _;
        },
        userCanEditSocialSeries() {
			const userId = localStorage.getItem("userId");
            const socialSeries = this.socialSeriesDetail;

            if (this.userAbilities.accessAllSocialSeries) {
                return this.userAbilities.editSocialSeries;
            }

            let isManager = false;
            if (socialSeries.engagement_manager instanceof Object) {
                isManager = userId == socialSeries.engagement_manager.id;
            } else {
                isManager = userId == socialSeries.engagement_manager;
            }

            return (this.userAbilities.editSocialSeries && isManager);
        },
    },
    methods: {
        ...mapActions({
        	createSocialSeries (dispatch, payload) {
        	  return dispatch(this.namespace + 'createSocialSeries', payload)
        	},
        	updateSocialSeriesFieldValue (dispatch, payload) {
        	  return dispatch(this.namespace + 'updateSocialSeriesFieldValue', payload)
        	},
        }),
        activateTitleField() {
            this.editTitle = true;
            let that = this;
            setTimeout(() => {
                that.$refs.editTitleRef.select();
            }, 100);
        },
        clickOutsideTitle() {
            this.editTitle = false;
        },

        showEngagementManager() {
            this.emEditing = true;
            this.$nextTick(() => {
                this.$refs.emSelect.$el.focus();
            })
        },
        showProjectLead() {
            this.plEditing =  true;
            this.$nextTick(() => {
                this.$refs.plSelect.$el.focus();
            })
        },
        changeEngagementManager(v1, v2) {
            
        },
        changeProjectLead() {

        },

        clickOutsideEM() {
            this.emEditing = false;
        },
        clickOutsidePL() {
            this.plEditing = false;
        },
        /*
        onToday(dateType) {
            if (dateType == "startDate") {
                this.socialSeries.start_date = this.$moment().format();
                this.$refs.startDatePicker.close();
            }
            else if (dateType == "endDate") {
                this.socialSeries.end_date = this.$moment().format();
                this.$refs.endDatePicker.close();
            }
        },
        onRemoveDate(dateType) {
            if (dateType == "startDate") {
                this.socialSeries.start_date = null;
                this.$refs.startDatePicker.close();
            }
            else if (dateType == "endDate") {
                this.socialSeries.end_date = null;
                this.$refs.endDatePicker.close();
            }
        },
        */

        createSeries() {
            this.socialSeries.engagement_manager = this.socialSeries.engagement_manager.id;
            this.socialSeries.project_lead = this.socialSeries.project_lead.id;

            this.createSocialSeries(this.socialSeries);

            this.$emit("socialSeriesCreated", this.socialSeries);
        },

        close() {
            this.$emit("socialSeriesClose");
        },


        budgetClick() {
            this.budgetEditing = true;
            setTimeout(() => {
                this.$refs.budgetInput.select();
            }, 100);
        },
        budgetClickOutside() {
            this.budgetEditing = false;
        },

        requisitionNumberClick() {
            this.requisitionNumberEditing = true;
            setTimeout(() => {
                this.$refs.requisitionNumberInput.select();
            }, 100);
        },
        requisitionNumberClickOutside() {
            this.requisitionNumberEditing = false;
        },

        showResourceBox(url, parent_id) {
            let fileId = this.customChildFieldValue('file_id',parent_id);
            return (url != null || fileId != null);
        },
        customChildField(key, parent_id) {
            if (this.socialSeriesDetail.customFields) {
                let obj = _.filter(this.socialSeriesDetail.customFields, {field_key: key, parent_id:parent_id});
                if (obj.length > 0) {
                    // lets add it to the
                    return obj;
                } else {
                    if (key == 'file_id') return null;
                    if (key == 'link_type') return [];
                    // return the global version of the custom field...
                    // let obj = _.filter(this.allCustomFields, {field_key: key});
                    let field = _.filter(this.allCustomFields, {field_key: key});
                    obj = {};
                    obj.id = null;
                    obj.parent_id = this.socialSeriesDetail.customFields[index].id;
                    obj.social_series_id = this.socialSeriesDetail.customFields[index].social_series_id;
                    obj.editing = false;
                    obj.field_id = field[0].id;
                    obj.field_key = field[0].field_key;
                    obj.field_parent_id = field[0].parent_id;
                    obj.field_type = field[0].field_type;
                    obj.note = field[0].note;
                    obj.value = null;
                    obj.label = field[0].label;
                    obj.value_set = field[0].value_set;
                    obj.updated_at = this.socialSeriesDetail.customFields[index].updated_at;
                    return [obj];
                }
            }
            return [];
        },
        customChildFieldValue(key, parent_id) {
            if (this.socialSeriesDetail.customFields) {
                let obj = _.filter(this.socialSeriesDetail.customFields, {field_key: key, parent_id:parent_id});
                if (obj.length > 0) {
                return obj[0].value;
                } else {
                return null;
                }
            }
            return null;
        },

        // Resources
        addResourceMenuItemClick(typeId, e) {
            e.preventDefault();
            this.addResource(typeId);
        },
        editResource(resource) {
            this.linkUrl = resource;
            let label =  this.customChildField('link_label', resource.ssfv_id);
            if (label.length > 0) {
                this.linkLabel = label[0];
            } else {
                this.linkLabel = {};
            }
            let notes =  this.customChildField('link_notes', resource.ssfv_id);
            if (notes.length > 0) {
                this.linkNotes = notes[0];
            } else {
                this.linkNotes = {};
            }
            let type = this.customChildField('link_type', resource.ssfv_id);
            if (type.length > 0) {
                this.linkType = type[0];
            } else {
                this.linkType = {
                id:null,
                field_id:37,
                social_series_field_id: _.filter(this.socialSeriesDetail.customFields, {field_key: 'link_type'})[0]?.socialSeriesFieldId,
                parent_field_id: 20,
                field_key: "link_type",
                field_type: "select",
                parent_id: null,
                social_series_id: this.socialSeriesDetail.id,
                value:1
                };
            }
            let fileId = this.customChildField('file_id', resource.ssfv_id);
            this.editLinkIsFile = Boolean(fileId);
            this.$bvModal.show("editLinkModal");
        },
        addResource(typeId = 1) {
            this.linkUrl = {
                id:null,
                field_id:20,
                social_series_field_id:_.filter(this.socialSeriesDetail.customFields, {field_key: 'link_url'})[0].socialSeriesFieldId,
                parent_field_id:null,
                field_key:"link_url",
                field_type:"text",
                parent_id:null,
                social_series_id: this.socialSeriesDetail.id,
                value:null
            };
            this.linkLabel = {
                id:null,
                field_id:21,
                social_series_field_id:_.filter(this.socialSeriesDetail.customFields, {field_key: 'link_label'})[0].socialSeriesFieldId,
                parent_field_id:20,
                field_key:"link_label",
                field_type:"text",
                parent_id:null,
                social_series_id: this.socialSeriesDetail.id,
                value:null
            };
            this.linkNotes = {
                id:null,
                field_id:22,
                social_series_field_id:_.filter(this.socialSeriesDetail.customFields, {field_key: 'link_notes'})[0].socialSeriesFieldId,
                parent_field_id:20,
                field_key:"link_notes",
                field_type:"text",
                parent_id:null,
                social_series_id: this.socialSeriesDetail.id,
                value:null
            };
            this.linkType = {
                id:null,
                field_id:37,
                social_series_field_id:_.filter(this.socialSeriesDetail.customFields, {field_key: 'link_type'})[0].socialSeriesFieldId,
                parent_field_id:20,
                field_key:"link_type",
                field_type:"select",
                parent_id:null,
                social_series_id: this.socialSeriesDetail.id,
                value:typeId
            };
            this.$bvModal.show("createLinkModal");
        },
        focusLinkModal() {
            this.$refs.refLinkModal.focusMyElement();
        },
        focusEditLinkModal() {
            this.$refs.refEditLinkModal.focusMyElement();
        },
        removeSocialSeries() {
          this.showRemoveSocialSeries = true;
        },

        onConfirmRemoveSocialSeries() {
          if (this.socialSeriesDetail.id) {
            let that = this;
            let socialSeriesId = this.socialSeriesDetail.id;
            let socialSeriesTemplateId = this.socialSeriesDetail.socialSeries_template_id;
            this.$store.dispatch("removeSocialSeries", { socialSeriesId:this.socialSeriesDetail.id }).then(function() {
              that.$bvModal.hide("editSocialSeriesModal");
              // TODO: removing a socialSeries should only remove it from the list, not replace entire list.

              that.$store.dispatch('fetchSocialSeries').then(function() {
                toast.hide();

                // if (socialSeriesTemplateId == 1) {
                // 	that.$store.dispatch('manageUndoActivation', 'Media call deleted.');
                // } else {
                // }
                that.$store.dispatch('manageUndoActivation', 'SocialSeries deleted.');

              	// that.$store.dispatch('fetchProjectSocialSeries');
              });
            });
          }
        },

        updateSocialSeries() {
            this.$store.dispatch("updateSocialSeries", this.socialSeriesDetail);
        },

        getLinkTypeObject(id) {
            if (id == null) id = 1;
            const r = this.optionsForLinkType.find(x => x.id == id);
            return r;
        },

        openCopyLinkModal(link, e, i) {
            if (!link.includes("\\")) {
                return;
            }
            e.preventDefault();
            this.copyLink(link, i);
        },
        async copyLink(link, resourceId) {
            clearTimeout(this.linkCopyLinkTimeouts[resourceId]);
            Object.keys(this._.filter(this.socialSeriesDetail.customFields, {field_key: 'link_url'})).forEach(x => {
                if (x == resourceId) return;
                this.$root.$emit('bv::hide::tooltip', 'social-series-resource-' + x);
            })

            const navPer = await navigator.permissions.query({name: "clipboard-write"});
            if (navPer.state == "granted" || navPer.state == "prompt") {
                try {
                    await navigator.clipboard.writeText(link);
                } catch {
                    console.error("clipboard API error. Cannot copy to clipboard.");
                    this.legacyCopyMethod(link);
                }
            } else {
                this.legacyCopyMethod(link);
            }

            this.$root.$emit('bv::show::tooltip', 'social-series-resource-' + resourceId);
            this.linkCopyLinkTimeouts[resourceId] = setTimeout(() => {
                this.$root.$emit('bv::hide::tooltip', 'social-series-resource-' + resourceId);
            }, 2000);
        },
    },
    mounted() {
        //console.log(this.socialSeriesDetail);
    },
}
</script>

<style scoped>
.type-label {
    color: var(--wf-primary);
	display:block;
	font-weight: 400;
	font-size: 1em;
	text-transform:uppercase;
}
.group-title-wrapper {
	width:100%;
	}
h1 {
	font-size:22px;
}
h1.edit-d-title::after {
	background:transparent;
	right:-40px;
	}
textarea.title-field {
	font-size:22px;
}
</style>